import { HOST } from "../config";
import axios from "axios";
import { getMycorpAPI } from "./my_service";
import { adminApi } from "./adminApis";

const token = localStorage.getItem("access_token");
const headers = {
  Authorization: `Bearer ${token}`,
};

//종목 검색
export async function searchStock(stock) {
  const params = {
    searchword: stock,
  };
  try {
    const res = await axios.get(`${HOST}/stocks/search`, { params: params });
    if (res.data.resultcode === "200") {
      return res.data.data;
    } else return null;
  } catch (err) {
    return null;
  }
}

//메인 홈화면 데이터 (전체기업/산업/테마)
export async function getHomeDataAPI(category, type, order, limit = 3) {
  try {
    const res = await axios.get(
      `${HOST}/home/${category}?type=${type}&orderstandard=${order}&newslimit=${limit}`
    );
    return res.data.data;
  } catch (err) {
    window.location.replace("/error");
    return null;
  }
}

//실시간 종목 관련 뉴스 데이터 (IF_MP_00005)
export async function getRealtimeNewsAPI(params) {
  try {
    if (params?.category === "polistar") {
      const poliRes = await adminApi.get(
        `/polistar/list?page=${params.page}&startdt=${params.startdate}&enddt=${params.enddate}`
      );
      if (poliRes.data.resultcode === "200") {
        return poliRes.data.data.news_list;
      } else return [];
    } else {
      const res = await axios.get(`${HOST}/news/realtime?`, { params: params });
      if (res.data.resultcode === "200") {
        return res.data.data;
      } else return [];
    }
  } catch (err) {
    return null;
  }
}

//실시간 산업 관련 뉴스 데이터 (IF_MP_00006)
export async function getIndustryRealtimeNewsAPI(params) {
  const url = Object.keys(params)
    .map((el) => el + "=" + params[el])
    .join("&");
  const category = !!params["industry"] ? "industry" : "theme";

  try {
    const res = await axios.get(`${HOST}/news/${category}/realtime?${url}`);
    if (res.data.resultcode === "200") {
      return res.data.data;
    } else return [];
  } catch (err) {
    return null;
  }
}

//연관뉴스 리스트
export async function getSimilarNewsAPI(newsId, size) {
  try {
    const res = await axios.get(
      `${HOST}/news/similar?page=1&size=${size}&newsid=${newsId}`
    );
    if (res.data.resultcode === "200") {
      return res.data.data;
    } else {
      // window.location.assign('/nodata')
      return [];
    }
  } catch (err) {
    window.location.assign("/error");
    return null;
  }
}

/***************************싱글뉴스페이지**********************************/

//단일 뉴스의 데이터 조회
export async function getSingleNewsAPI(newsId) {
  try {
    const res = await axios.get(`${HOST}/news/realtime?newsid=${newsId}`);
    if (res.data.resultcode === "200") {
      return res.data.data;
    } else {
      window.location.assign("/nodata");
      return null;
    }
  } catch (err) {
    window.location.assign("/error");
    return null;
  }
}

//단일 뉴스의 키워드 조회
export async function getKeywordAPI(newsId) {
  try {
    const res = await axios.get(
      `${HOST}/news/keywords?newsid=${newsId}&newslistyn=Y`
    );
    if (res.data.resultcode === "200") {
      return res.data.data;
    } else return [];
  } catch (err) {
    return null;
  }
}

//단일뉴스의 키워드 클릭시 연관기업 조회
export async function getKeywordRelatedStockAPI(keyword) {
  try {
    const res = await axios.get(
      `${HOST}/news/keywords/stock?keyword=${keyword}`
    );
    if (res.data.resultcode === "200") {
      return res.data.data;
    } else return [];
  } catch (err) {
    return null;
  }
}

// 단일뉴스 기업의 큐레이팅 데이터
export async function getSingleNewsCurateAPI(stockcode, type) {
  try {
    const res = await axios.get(
      `${HOST}/stocks/dailyreport/stocks?stockcode=${stockcode}&type=${type}`
    );
    if (res.data.resultcode === "200") {
      return res.data.data;
    } else return null;
  } catch (err) {
    return null;
  }
}

//단일 공시뉴스의 데이터 조회
export async function getDartNewsAPI(newsId) {
  try {
    const res = await axios.get(
      `${HOST}/news/realtime?newsid=${newsId}&category=dart`
    );
    if (res.data.resultcode === "200") {
      return res.data.data;
    } else {
      window.location.assign("/nodata");
      return null;
    }
  } catch (err) {
    window.location.assign("/error");
    return null;
  }
}

export async function getCorpDartNewsesAPI(stockcode) {
  try {
    const res = await axios.get(
      `${HOST}/news/realtime?stockcode=${stockcode}&category=dart`
    );
    if (res.data.resultcode === "200") {
      return res.data.data;
    } else {
      window.location.assign("/nodata");
      return null;
    }
  } catch (err) {
    window.location.assign("/error");
    return null;
  }
}

// 폴리스타에 연동된 정치인 리포트 및 인삿말 개별뉴스 조회
export async function getPolistarNewsesAPI(newId) {
  try {
    const poliRes = await adminApi.get(`/polistar/list/${newId}`);
    if (poliRes.data.resultcode === "200") {
      return poliRes.data.data;
    } else {
      window.location.assign("/nodata");
      return null;
    }
  } catch (err) {
    window.location.assign("/error");
    return null;
  }
}

/*******************DETAIL PAGE ************************/

//디테일 페이지 랭킹 데이터 조회
export async function getRankingDataAPI(category = "industry", limit) {
  try {
    const res = await axios.get(`${HOST}/${category}/rank?limit=${limit}`);
    if (res.data.resultcode === "200") {
      return res.data.data;
    } else return null;
  } catch (err) {
    return null;
  }
}

//디테일 페이지 뉴스, 큐레이팅 데이터 조회 (IF_W_NS_00032)
export async function getDetailDataAPI(category = "industry", name, code) {
  try {
    const groupcode = category === "industry" ? name : code;
    const res = await axios.get(`${HOST}/${category}/summary/${groupcode}`);
    if (res.data.resultcode === "200") {
      return res.data.data;
    } else return null;
  } catch (err) {
    return null;
  }
}

//디테일 페이지 뉴스 목록 조회 (IF_W_NS_00032)
export async function getDetailNewsAPI() {
  const params = {};
  try {
    const res = await axios.get(`${HOST}/news/industry/realtime`, {
      params: params,
    });
    if (res.data.resultcode === "200") {
      return res.data.data;
    } else return null;
  } catch (err) {
    return null;
  }
}

/********************* STOCK PAGE **************************/

//종목 기본 정보  (IF_MP_00024)
export async function getStockDataAPI(stockcode) {
  try {
    const res = await axios.get(`${HOST}/stocks/${stockcode}`);
    if (res.data.resultcode === "200") {
      return res.data.data;
    } else return null;
  } catch (err) {
    return null;
  }
}

//종목 데일리 리포트, 큐레이팅 조회 (IF_MP_00009)
export async function getReportDataAPI(category = "industry", stockcode) {
  try {
    const res = await axios.get(
      `${HOST}/stocks/dailyreport/${category}?stockcode=${stockcode}&type=3`
    );
    if (res.data.resultcode === "200") {
      return res.data.data;
    } else return {};
  } catch (err) {
    return null;
  }
}

//종목 관련 키워드 조회 IF_MP_00028
export async function getStockKeywordAPI(stockcode) {
  try {
    const res = await axios.get(`${HOST}/stocks/keyword/${stockcode}`);
    if (res.data.resultcode === "200") {
      return res.data.data;
    } else return null;
  } catch (err) {
    return null;
  }
}

//테마/산업 관련 뉴스 목록 조회(IF_MP_00006)
export async function getIndustryNThemeNewsAPI(
  category,
  name,
  themeCode,
  react = null
) {
  const params = {};
  params["signal"] = react;
  const target = category === "theme" ? themeCode : name;
  try {
    const res = await axios.get(
      `${HOST}/news/${category}/realtime?${category}=${target}`,
      { params: params }
    );
    if (res.data.resultcode === "200") {
      return res.data.data;
    } else {
      return [];
    }
  } catch (err) {
    window.location.assign("/error");
    return null;
  }
}

//헤더 > 기업 (오늘의 추천)종목 조회 (IF_MP_00025)
//헤더 > 기업 로그인 시 종목 조회 (IF_MP_00025)
export async function getStockcode() {
  try {
    const randomIdx = Math.floor(Math.random() * 10); //0~9사이 랜덤 숫자
    const res = await axios.get(`${HOST}/stocks/list?orderstandard=CHANGE`); //비로그인 시 추천종목 중
    const myres = await axios.get(`${HOST}/user/interest`, {
      headers: headers,
    }); //로그인 시 마이종목 중

    if (!!token && myres.data.resultcode === "200") {
      return myres.data.data[randomIdx].stockcode;
    } else {
      if (res.data.resultcode === "200") {
        return res.data.data[randomIdx].stockcode;
      }
    }
    return "113810";
  } catch (err) {
    return null;
  }
}

export async function getStockcode2() {
  let favstockcodes = "";
  try {
    const randomIdx = Math.floor(Math.random() * 10); //0~9사이 랜덤 숫자

    const mycorps = getMycorpAPI().then((res) => {
      favstockcodes = res?.map((stock) => stock.stockcode).join("|");

      return favstockcodes;
    });

    const res = await axios.get(`${HOST}/stocks/list?orderstandard=POPULAR`); // 로그인 안했을 때

    const myres = await mycorps.then((code) => {
      if (!!code) {
        return axios.get(`${HOST}/stocks/list?favstockcodes=${code}`);
      }
    }); //로그인 했을 때

    if (!!token && myres.data.resultcode === "200") {
      return myres.data.data[randomIdx];
    } else {
      return res.data.data[randomIdx];
    }
  } catch (err) {
    return null;
  }
}

/******************** 뉴스 목록 ************************/

//검색 뉴스 갯수 조회
export async function getNewsCnt(params) {
  try {
    if (params?.category === "polistar") {
      const poliRes = await adminApi.get(
        `/polistar/list?page=${params.page}&startdt=${params.startdate}&enddt=${params.enddate}`
      );
      if (poliRes.data.resultcode === "200") {
        return poliRes.data.data.total_cnt;
      } else return 10;
    }
    const res = await axios.get(`${HOST}/news/realtime/cnt`, {
      params: params,
    });
    if (res.data.resultcode === "200") {
      return res.data.data.n_cnt;
    } else {
      return 10;
    }
  } catch (err) {
    return null;
  }
}

/******************** 나인메모스의 리포트 조회 ************************/
export async function getNewsStockfactorReport(params) {
  try {
    const res = await axios.get(`${HOST}/news/stockfactor/report`, {
      params: params,
    });
    if (res.data.resultcode === "200") {
      return res.data.data;
    } else {
      return null;
    }
  } catch (err) {
    return null;
  }
}
